<script>
import resources from './resources'

export default {
  name: 'back-to-index',
  mixins: [resources]
}
</script>

<template lang="pug">
  .col-xs-12(style='padding-top: 30px')
    button.btn.find-filled.btn-margin-alert(@click='backToIndex()')
      span.icon 
      |Fechar
      
</template>
<style scoped>
h3 {
  font-size: 16px;
}
.mb-alert-title {
    color: #595959;
    font-size: 30px;
    text-align: center;
    font-weight: 600;
    text-transform: none;
    position: relative;
    margin: 0 0 .4em;
    padding: 0;
    display: block;
    word-wrap: break-word;
}
.mb-alert-content {
    font-size: 18px;
    text-align: center;
    font-weight: 600;
    position: relative;
    float: none;
    margin: 0;
    padding: 0;
    line-height: normal;
    color: #545454;
    word-wrap: break-word;
}
.label-size {
  font-size: 16px;
  color: #868585
}
</style>



// WEBPACK FOOTER //
// src/app/professional/company/addresses/components/back-to-index.vue